import authSdk from '../sdk'

const baseURL = import.meta.env.APP_AUTOMATION_API_URL
const automation = authSdk.createAxiosInstance({
    baseURL,
})

export default automation
